import React from 'react';
import { Column } from 'Shared/components';
import { useAppContext } from 'QuoteApp/services/providers';
import { NoResults } from '../../NoResults';
import { ReportDetailHeaderRow } from '../../ReportDetailHeaderRow';
import { AccidentForm } from './AccidentForm';
import { DriverReportType } from '../../types';
import { AccidentDataType } from 'QuoteApp/services/endpoints/GetDetails';
import { useQuoteAppFeatureFlags } from 'QuoteApp/utils/hooks/useQuoteAppFeatureFlags';

export const AccidentsReport: DriverReportType = ({ driverId }) => {
  const { details } = useAppContext();

  const {
    assumeAtFaultFlag,
    collectTypeOfLossFlag,
  } = useQuoteAppFeatureFlags();

  const accidents: Record<string, AccidentDataType> = Object.keys(
    details.drivers[driverId].accidents
  )
    .filter(key => {
      const accident = details.drivers[driverId].accidents[key];
      return (
        !accident.isLendingLoss && accident.claimStatus.value !== 'Collapsed'
      );
    })
    .reduce((obj, accidentId) => {
      return {
        ...obj,
        [accidentId]: details.drivers[driverId].accidents[accidentId],
      };
    }, {});

  const canChallenge = Object.keys(
    details.commands.drivers[driverId].accidents
  ).some(id =>
    details.commands.drivers[driverId].accidents[id].some(
      c => c.name === 'challenge_accident'
    )
  );

  return (
    <div data-testid="accidents-report-details">
      <ReportDetailHeaderRow canChallenge={canChallenge} includeRemove claim>
        <Column variant="quarter">Accident Date</Column>
        {collectTypeOfLossFlag && (
          <>
            <Column variant="quarter">Claim Type</Column>
            <Column variant="sixth">Loss Amount</Column>
          </>
        )}
        {!assumeAtFaultFlag && <Column variant="quarter">Fault</Column>}
      </ReportDetailHeaderRow>
      {Object.keys(accidents).length ? (
        <ul>
          {Object.values(accidents).map(({ identifier }) => (
            <AccidentForm
              key={identifier}
              driverId={driverId}
              incidentId={identifier}
              canChallenge={canChallenge}
            />
          ))}
        </ul>
      ) : null}
      <NoResults isVisible={!Object.keys(accidents).length}>
        No accidents discovered
      </NoResults>
    </div>
  );
};
